import { render } from "./Note.vue?vue&type=template&id=34551322&scoped=true"
import script from "./Note.vue?vue&type=script&lang=js"
export * from "./Note.vue?vue&type=script&lang=js"

import "./Note.vue?vue&type=style&index=0&id=34551322&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34551322"],['__file',"src/components/Note.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "34551322"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34551322', __exports__)) {
    api.reload('34551322', __exports__)
  }
  
  module.hot.accept("./Note.vue?vue&type=template&id=34551322&scoped=true", () => {
    api.rerender('34551322', render)
  })

}


export default __exports__